const LOCAL_SKIP_KEY = "descripio_marketplace_skip_local";
const PENDING_SKIP_KEY = "descripio_marketplace_skip_pending";

const withTimeout = async (promise, timeoutMs) => {
  return Promise.race([
    promise,
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error("skipAuthorization timeout")), timeoutMs);
    }),
  ]);
};

const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // no-op
  }
};

const safeRemove = (key) => {
  try {
    localStorage.removeItem(key);
  } catch {
    // no-op
  }
};

const safeGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const hasMarketplaceSkipOverride = () => {
  return safeGet(LOCAL_SKIP_KEY) === "1" || safeGet(PENDING_SKIP_KEY) === "1";
};

export const persistMarketplaceSkip = async (skipAuthorizationFn) => {
  // Keep a local fallback while waiting for backend skip_now persistence.
  safeSet(LOCAL_SKIP_KEY, "1");
  safeSet(PENDING_SKIP_KEY, "1");

  try {
    await skipAuthorizationFn();
    safeRemove(PENDING_SKIP_KEY);
    return true;
  } catch {
    // Backend failed — PENDING flag stays so syncMarketplaceSkipIfPending
    // will retry on next login.
    return false;
  }
};

export const syncMarketplaceSkipIfPending = async (skipAuthorizationFn) => {
  if (safeGet(PENDING_SKIP_KEY) !== "1") {
    return true;
  }

  try {
    await withTimeout(skipAuthorizationFn(), 3500);
    safeRemove(PENDING_SKIP_KEY);
    safeSet(LOCAL_SKIP_KEY, "1");
    return true;
  } catch {
    return false;
  }
};
